/**
 * @ngdoc module
 * @name vrm.core
 * @description VRM core module
 */

(function() {
    'use strict';

    angular.module('vrm.core')
        .config(EconomicReportingConfig);

    /**
     * @constructor
     * @ngInject
     */
    function EconomicReportingConfig($stateProvider) {

        // set available routes
        $stateProvider
            .state('base.installation.reporting.economic', {
                url: '/economic',
                views: {
                    "reporting": {
                        template: require('@/angular/views/core/installation/reporting/economic.html'),
                        controller: 'EconomicController'
                    }
                }
            })
            .state('base.installation.reporting.economic-result', {
                url: '/economic-result?scenario&start&end&fuel_litre_price&genset_maintenance_costs&grid_kwh_price&solar_maintenance_costs&genset_size_kva&currency&grid_kwh_sell_price',
                views: {
                    "reporting": {
                        template: require('@/angular/views/core/installation/reporting/economic-result.html'),
                        controller: 'EconomicController'
                    }
                }
            });
    }
})();
